// Egyptian Pound (EGP) is the default app currency for accounting / subscriptions
export const APP_CURRENCY = "EGP" as const;
export const CURRENCY_SYMBOL = "ج.م"; // جنيه مصري

// Egyptian VAT (Value Added Tax) standard rate
export const EGYPT_VAT_RATE = 14;

export const formatCurrency = (
  amount: number | null | undefined,
  opts: { withSymbol?: boolean; decimals?: number } = {}
) => {
  const { withSymbol = true, decimals = 2 } = opts;
  const n = Number(amount || 0);
  const formatted = n.toLocaleString("ar-EG", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return withSymbol ? `${formatted} ${CURRENCY_SYMBOL}` : formatted;
};

export interface VatBreakdown {
  subtotal: number;
  vatRate: number;
  vatAmount: number;
  total: number;
}

/** Treats `gross` as VAT-inclusive and extracts the subtotal + VAT portions. */
export const breakdownInclusive = (
  gross: number,
  vatRate: number = EGYPT_VAT_RATE
): VatBreakdown => {
  const total = Number(gross || 0);
  const subtotal = total / (1 + vatRate / 100);
  return {
    subtotal: Math.round(subtotal * 100) / 100,
    vatRate,
    vatAmount: Math.round((total - subtotal) * 100) / 100,
    total: Math.round(total * 100) / 100,
  };
};

/** Treats `net` as the pre-tax amount and adds VAT on top. */
export const breakdownExclusive = (
  net: number,
  vatRate: number = EGYPT_VAT_RATE
): VatBreakdown => {
  const subtotal = Number(net || 0);
  const vatAmount = (subtotal * vatRate) / 100;
  return {
    subtotal: Math.round(subtotal * 100) / 100,
    vatRate,
    vatAmount: Math.round(vatAmount * 100) / 100,
    total: Math.round((subtotal + vatAmount) * 100) / 100,
  };
};
